angular.module('app').directive("browseServer", [
    '$compile',
    'mediaService',
    '$uibModal',
    function ($compile, mediaService, $modal) {
        return {
            priority: 1001,
            restrict: "E",
            replace: true,
            templateUrl: "views/directives/browseServer.html",
            compile: function (element) {
                var previewHtml = "<div ng-show=\"!!imageToLoad\"><div style=\"height: 400px;width: 350px\"><img ng-src=\"{{imageToLoad.fileUrl}}\" > </div></div>",
                    template,
                    dragElem = $(element).parent().find(".drug-file-contain");

                template = angular.element(previewHtml);
                dragElem.after(template);

                template = $compile(template);

                return function (scope) {
                    template(scope);
                    scope.openBrowseFromServer = function () {
                        var modalInstance = $modal.open({
                            templateUrl: "views/browseServer/browseFromServer.html",
                            controller: "BrowseFromServerModalController",
                            resolve: {
                                preloadedImages: function () {
                                    return mediaService.getImages().then(
                                        function (response) {
                                            if (response.status == "ok") {
                                                return angular.copy(response.items || []);
                                            } else {
                                                errorHandler(response.message);
                                                return [];
                                            }
                                        }
                                    )
                                }
                            }
                        });

                        modalInstance.result.then(
                            function (result) {
                                if (result && result[0] && result[0].fileUrl) {
                                    scope.imageToLoad = result[0];
                                    scope.pageData.forceTOChange = true
                                }
                            }
                        )
                    }
                }
            }
        }
    }
]);
